import React from 'react'
import { AnnouncementBar } from '../../components/layout/announcement-bar'
import { HeaderScroll } from '../../components/layout/header-scroll'
import { SiteFooter } from '../../components/layout/site-footer'
import { SiteHeader } from '../../components/layout/site-header'
import { AuthProvider } from '../../lib/auth'

export function RootLayout({ children }: { children: React.ReactNode }) {
  // The session wraps everything, because the header shows who is signed in
  // and any page may need to know. It resolves to "signed out" immediately
  // during the static build, where there is no browser to hold a session.
  return (
    <AuthProvider>
      <a href="#main" className="skip-link">Skip to main content</a>
      <HeaderScroll />
      <AnnouncementBar />
      <SiteHeader />
      <main id="main">{children}</main>
      <SiteFooter />
    </AuthProvider>
  )
}
